// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Decoder$AppTemplateReasonReact from "../models/Decoder.bs.js";

function useStories(param) {
  var match = React.useState(function () {
        return [];
      });
  var setStories = match[1];
  var getStories = function (param) {
    var __x = fetch("https://hn.algolia.com/api/v1/search?tags=front_page");
    var __x$1 = __x.then(function (prim) {
          return prim.json();
        });
    var __x$2 = __x$1.then(function (obj) {
          return Promise.resolve(Decoder$AppTemplateReasonReact.hitsData(obj));
        });
    return __x$2.then(function (hits) {
                return Promise.resolve((Curry._1(setStories, (function (param) {
                                    return hits.hits;
                                  })), undefined));
              });
  };
  return [
          match[0],
          getStories
        ];
}

function useStory(param) {
  var match = React.useState(function () {
        
      });
  var fetchStory = function (id) {
    var __x = fetch("https://hn.algolia.com/api/v1/items/" + id);
    var __x$1 = __x.then(function (prim) {
          return prim.json();
        });
    return __x$1.then(function (obj) {
                return Promise.resolve(Decoder$AppTemplateReasonReact.storyData(obj));
              });
  };
  return [
          match[0],
          match[1],
          fetchStory
        ];
}

export {
  useStories ,
  useStory ,
  
}
/* react Not a pure module */
